import { ReactElement } from 'react';
import CaFlag from '../../../assets/flags/CaFlag';
import AuFlag from '../../../assets/flags/AuFlag';

type FlagSwitcherProps = {
    country: string;
    width?: string;
    height?: string;
};

function FlagSwitcher({ country, width, height }: FlagSwitcherProps): ReactElement {
    if (country === 'Canada') {
        return <CaFlag width={width} height={height} />;
    } else if (country === 'Australia') {
        return <AuFlag width={width} height={height} />;
    } else {
        return <CaFlag width={width} height={height} />;
    }
}

export default FlagSwitcher;
